export default "__VITE_ASSET__CAKxTcvd__"